import {Route, Routes} from "react-router-dom";
import {RecoilRoot} from "recoil";
import Loader from "./component/Loader";
import ProductCodeCreatePage from "./page/product/ProductCodeCreatePage";
import ProductCodeListPage from "./page/product/ProductCodeListPage";
import ProductCodeUpdatePage from "./page/product/ProductCodeUpdatePage";
import PromoListPage from "./page/promo/PromoListPage";
import PromoCreateOrUpdatePage from "./page/promo/PromoCreateOrUpdatePage";
import CouponCampaignListPage from "./page/coupon/CouponCampaignListPage";
import CouponCampaignCreateOrUpdatePage from "./page/coupon/CouponCampaignCreateOrUpdatePage";
import CouponCampaignCodesPage from "./page/coupon/CouponCampaignCodesPage";
import BusinessAgreementListPage from "./page/businessAgreement/BusinessAgreementListPage";
import AffiliateListPage from "./page/affiliate/AffiliateListPage";
import BusinessAgreementCreateOrUpdatePage from "./page/businessAgreement/BusinessAgreementCreateOrUpdatePage";
import ProcurerListPage from "./page/procurer/ProcurerListPage";
import AffiliateUpdatePage from "./page/affiliate/AffiliateUpdatePage";
import ProcurerUpdatePage from "./page/procurer/ProcurerUpdatePage";
import LeisureAgreementListPage from "./page/leisureAgreement_new/LeisureAgreementListPage";
import LeisureAgreementCreateOrUpdatePage from "./page/leisureAgreement_new/LeisureAgreementCreateOrUpdatePage";
import PoiListPage from "./page/poi/PoiListPage";
import PoiCreateOrUpdatePage from "./page/poi/PoiCreateOrUpdatePage";
import VoucherListPage from "./page/voucher/VoucherListPage";
import VoucherUpdatePage from "./page/voucher/VoucherUpdatePage";
import SubscriptionListPage from "./page/subscriptions/SubscriptionListPage";
import SubscriptionCreateOrUpdatePage from "./page/subscriptions/SubscriptionCreateOrUpdatePage";
import ContractListPage from "./page/contract/ContractListPage";
import ContractUpdatePage from "./page/contract/ContractUpdatePage";
import PageNotFound from "../../util/page/PageNotFound";
import DetectionListPage from "./page/detection/DetectionListPage";
import PaOrdersListPage from "./page/paOrders/PaOrdersListPage";
import PaOrdersCreateOrUpdatePage from "./page/paOrders/PaOrdersCreateOrUpdatePage";

const SalesMarketingMain = () => {

    return (
        <RecoilRoot key='salesmarketing'>
            <Routes>
                <Route path="/productcodelist" element={
                    <ProductCodeListPage/>
                }/>
                <Route path="/productcodecreate" element={
                    <ProductCodeCreatePage/>
                }/>
                <Route path="/productcodeupdate" element={
                    <ProductCodeUpdatePage/>
                }/>
                <Route path="/promolist" element={
                    <PromoListPage/>
                }/>
                <Route path="/promocreate" element={
                    <PromoCreateOrUpdatePage/>
                }/>
                <Route path="/promoupdate" element={
                    <PromoCreateOrUpdatePage/>
                }/>
                <Route path="/promoupdate/:promoId" element={
                    <PromoCreateOrUpdatePage/>
                }/>
                <Route path="/couponcampaignlist" element={
                    <CouponCampaignListPage/>
                }/>
                <Route path="/couponcampaigncreate" element={
                    <CouponCampaignCreateOrUpdatePage/>
                }/>
                <Route path="/couponcampaignupdate/:couponCampaignId" element={
                    <CouponCampaignCreateOrUpdatePage/>
                }/>
                <Route path="/couponcampaigncodes/:couponCampaignId" element={
                    <CouponCampaignCodesPage/>
                }/>
                <Route path="/businessagreementlist" element={
                    <BusinessAgreementListPage/>
                }/>
                <Route path="/businessagreementupdate/:businessAgreementId" element={
                    <BusinessAgreementCreateOrUpdatePage/>
                }/>
                <Route path="/businessagreementcreate" element={
                    <BusinessAgreementCreateOrUpdatePage/>
                }/>
                <Route path="/leisureagreementlist" element={
                    <LeisureAgreementListPage/>
                }/>
                <Route path="/leisureagreementcreate" element={
                    <LeisureAgreementCreateOrUpdatePage/>
                }/>
                <Route path="/leisureagreementupdate/:leisureAgreementId" element={
                    <LeisureAgreementCreateOrUpdatePage/>
                }/>
                <Route path="/affiliatelist" element={
                    <AffiliateListPage/>
                }/>
                <Route path="/affiliateupdate/:affiliateId" element={
                    <AffiliateUpdatePage/>
                }/>
                <Route path="/intermediarylist" element={
                    <ProcurerListPage/>
                }/>
                <Route path="/intermediaryupdate/:procurerId" element={
                    <ProcurerUpdatePage/>
                }/>
                <Route path="/poilist" element={
                    <PoiListPage/>
                }/>
                <Route path="/poiupdate/:poiId" element={
                    <PoiCreateOrUpdatePage/>
                }/>
                <Route path="/poicreate" element={
                    <PoiCreateOrUpdatePage/>
                }/>
                <Route path="/subscriptionlist" element={
                    <SubscriptionListPage/>
                }/>
                <Route path="/subscriptionupdate/:subscriptionId" element={
                    <SubscriptionCreateOrUpdatePage/>
                }/>
                <Route path="/subscriptioncreate" element={
                    <SubscriptionCreateOrUpdatePage/>
                }/>
                <Route path="/voucherlist" element={
                    <VoucherListPage/>
                }/>
                <Route path="/voucherupdate/:voucherId" element={
                    <VoucherUpdatePage/>
                }/>
                <Route path="/subscriptionContractslist" element={
                    <ContractListPage/>
                }/>
                <Route path="/contractupdate/:contractId" element={
                    <ContractUpdatePage/>
                }/>
                <Route path="/detectionlist/:subscriptionId" element={
                    <DetectionListPage/>
                }/>
                <Route path="/paorderslist" element={
                    <PaOrdersListPage/>
                }/>
                <Route path="/paordercreate" element={
                   <PaOrdersCreateOrUpdatePage/>
                }/>
                <Route path="/paorderupdate/:orderId" element={
                    <PaOrdersCreateOrUpdatePage/>
                }/>
                <Route path="*" element={<PageNotFound/>}/>
            </Routes>
            <Loader/>
        </RecoilRoot>
    );
}

export default SalesMarketingMain;
